import React from 'react';
import { FormattedMessage } from 'react-intl';

import styled from 'styled-components';
import AppCircular from '../../Progress/AppCircular';

const OuterWrapper = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
`;

const Text = styled.p`
  color: #fca40c;
  margin-top: 1rem;
  font-size: 1.35rem;
  letter-spacing: 0.1rem;
`;

const AppLoader = () => (
  <OuterWrapper>
    <AppCircular size={50} />
    <Text>
      <FormattedMessage id='app.loading' />
    </Text>
  </OuterWrapper>
);

export default AppLoader;
